import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import { getLocale } from '.';
import translationEN from '../../locale/en-US/translation.json';
import translationES from '../../locale/es-ES/translation.json';
import translationPT from '../../locale/pt-BR/translation.json';

// All resources should be added to json language files so they're translated automatically
const resources = {
	'en-US': {
		translation: translationEN,
	},
	'pt-BR': {
		translation: translationPT,
	},
	'es-ES': {
		translation: translationES,
	},
};

// Set to default or chosen language
const lng = getLocale();

i18n.use(initReactI18next).init({
	resources,
	lng,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
